import moment from "moment";
import "moment/locale/es";

export function formatMonthYear(date) {
   
  debugger;

  if(date == null || date == undefined)
     date = getCurrentDate('/')

  return formatDate(date, "MMM YYYY");
}

export function getCurrentDate(separator=''){
  let newDate = new Date()
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();
  
  return `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date}`
  }

export function formatDate(date, format) {
  if(date){
    moment.locale("es");
    return moment(date).format(format);
  } 
  
  return "";
}
